// extracted by mini-css-extract-plugin
export default {"Body":"Layout_Body__5A7wY","Header":"Layout_Header__q9dpk"};